export default __webpack_public_path__ + "static/media/71-min.933190f6.jpg";